import * as NProgress from 'nprogress';
import 'nprogress/nprogress.css';

export class ProgressBar {
    constructor(naja: any) {
        naja.addEventListener('start', () => NProgress.start());
        naja.addEventListener('complete', () => NProgress.done());
    }
}
